import { RefreshCw } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { EflightSyncSection } from '@/components/sync/EflightSyncSection';
import { FsopSyncSection } from '@/components/sync/FsopSyncSection';
import { CalendarSubscriptionSection } from '@/components/sync/CalendarSubscriptionSection';
import { VaultSyncSection } from '@/components/sync/VaultSyncSection';
import { AutoLinkSection } from '@/components/sync/AutoLinkSection';

export function SyncCenterPage() {
  return (
    <div className="container mx-auto py-6 max-w-5xl">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center">
          <RefreshCw className="w-6 h-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">同步中心</h1>
          <p className="text-sm text-gray-500">管理所有数据同步设置和任务</p>
        </div>
      </div>

      <Tabs defaultValue="eflight">
        <TabsList className="mb-6">
          <TabsTrigger value="eflight">eFlight 同步</TabsTrigger>
          <TabsTrigger value="fsop">FSOP 同步</TabsTrigger>
          <TabsTrigger value="vault">Vault 同步</TabsTrigger>
          <TabsTrigger value="calendar">日历订阅</TabsTrigger>
          <TabsTrigger value="autolink">关联管理</TabsTrigger>
        </TabsList>

        <TabsContent value="eflight">
          <EflightSyncSection />
        </TabsContent>

        <TabsContent value="fsop">
          <FsopSyncSection />
        </TabsContent>

        <TabsContent value="vault">
          <VaultSyncSection />
        </TabsContent>

        <TabsContent value="calendar">
          <CalendarSubscriptionSection />
        </TabsContent>

        <TabsContent value="autolink">
          <AutoLinkSection />
        </TabsContent>
      </Tabs>
    </div>
  );
}
